import React, {useEffect, useMemo} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {t} from "i18next";
import {useSelector} from "react-redux";
import {stepOptions} from "../../flowManager/StepOptions";
import {PLUGIN_REFERER} from "../../../../src/constants";
import {projectTypeMainSlice, projectTypes} from "@arboxappv4/shared/src/helpers/constants";

const useTabName = (props) => {
    const { langReady } = props;
    const project_type = useSelector(state => state.project?.project_type)
    const box = useSelector(state => state[projectTypeMainSlice[project_type]]?.box)
    const currStep = useSelector(state => state.stepper.currStep)
    const targetName = useSelector(state => state.stepper.targetName)
    const referrer = useSelector(state => state.site?.referrer)
    const location = useLocation();
    const params = useParams();
    const isPlugin = useMemo(() => referrer === PLUGIN_REFERER, [referrer])
    const extras = useMemo(() => ` - ${box?.name} | Arbox`, [box]);

    useEffect(() => {
        if(location.pathname && params && langReady) {
            const name = getTabName()
            console.log('tab name: ',name)
            document.title = name
        }
    }, [location.pathname, params, langReady, targetName]);

    useEffect(() => {
        if(project_type === projectTypes.site && [stepOptions.PAYMENT, stepOptions.SUCCESS, stepOptions.WAIVER, stepOptions.AVAILABILITY_SLOT, stepOptions.COURSE_CHILD_DETAILS, stepOptions.COURSE_CHILD_SELECTION].includes(currStep)) {
            document.title = `${t(`${currStep}-tab-name`)}${extras}`
        } else {
            const name = getTabName()
            document.title = name
        }
    }, [currStep]);

    const getTabName = () => {
        if(project_type === projectTypes.kiosk) {
            return getKioskTabName()
        }
        const routeName = location.pathname.toLowerCase().split('/')[1]
        let tabName = ''
        if(targetName) {
            tabName = targetName
        } else {
            if (routeName === '') {
                if(isPlugin) {
                    tabName = t('lead-form-tab-name')
                } else {
                    tabName = t('home-tab-name')
                }
            } else if (routeName === '404') {
                tabName = t('not-found-tab-name')
            }
            else if (routeName === 'profile') {
                tabName = t(`${routeName}-${params.tab}-tab-name`)
            } else {
                tabName = t(`${routeName}-tab-name`)
            }
        }

        return `${tabName}${extras}`
    }

    const getKioskTabName = () => {
        const routeName = location.pathname.toLowerCase().split('/').filter(item => !['','kiosk'].includes(item))
        return t(`${routeName}-${currStep}-kiosk-tab-name`)
    }

};

export default useTabName;